export function buildUrl(
  baseUrl: string,
  params: Record<string, string>,
  origin = typeof window === 'undefined' ? undefined : window.location.origin
): string {
  try {
    if (!baseUrl.trim()) throw new Error('Empty URL');
    const url = new URL(baseUrl, origin);
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
    return url.toString();
  } catch {
    throw new Error(`Invalid URL: ${baseUrl}`);
  }
}
